import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

if (isDevMode()) {
  for (const level of ['warn', 'error'] as const) {
    const original = console[level];
    console[level] = (...args: unknown[]) => {
      if (typeof args[0] === 'string' && args[0].includes('NG01354')) return;
      original.apply(console, args);
    };
  }
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
